import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown, FiCheck } from 'react-icons/fi';

/**
 * Select simulado con divs para la gestión del ticket (dpto/prioridad/estado).
 * options: [{ value, label, badgeClass }]
 */
const TicketSelect = ({ options, value, onChange }) => {
    const [abierto, setAbierto] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const alClickFuera = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
        };
        const alEscape = (e) => {
            if (e.key === 'Escape') setAbierto(false);
        };
        document.addEventListener('mousedown', alClickFuera);
        document.addEventListener('keydown', alEscape);
        return () => {
            document.removeEventListener('mousedown', alClickFuera);
            document.removeEventListener('keydown', alEscape);
        };
    }, []);

    const seleccionada = options.find((opt) => opt.value === value);

    const elegir = (val) => {
        onChange(val);
        setAbierto(false);
    };

    return (
        <div className={`tk-select${abierto ? ' tk-select-abierto' : ''}`} ref={ref}>
            <button
                type="button"
                className="tk-select-trigger"
                onClick={() => setAbierto((prev) => !prev)}
                aria-haspopup="listbox"
                aria-expanded={abierto}
            >
                <span className={`tk-select-badge ${seleccionada?.badgeClass || ''}`}>
                    {seleccionada ? seleccionada.label : ''}
                </span>
                <FiChevronDown className="tk-select-chevron" />
            </button>
            {abierto && (
                <div className="tk-select-panel" role="listbox">
                    {options.map((opt) => (
                        <button
                            type="button"
                            role="option"
                            aria-selected={value === opt.value}
                            key={opt.value}
                            className={`tk-select-opcion${value === opt.value ? ' tk-select-opcion-activa' : ''}`}
                            onClick={() => elegir(opt.value)}
                        >
                            <span className={`tk-select-badge ${opt.badgeClass || ''}`}>{opt.label}</span>
                            {value === opt.value && <FiCheck className="tk-select-opcion-check" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TicketSelect;
